import { cn } from '@/lib/cn';
export function Kbd({ children, className }: { children: string; className?: string }) {
  return <kbd className={cn('inline-flex items-center h-[18px] px-[6px] rounded-[4px] border border-border bg-inset text-keycap text-ink-2 leading-none', className)}>{children}</kbd>;
}
